import { MdContentCopy, MdEdit, MdOutlineAccessTime } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { IABTestVariation } from '~/types/arbitration'

import ABTestVariations from '../ABTestVariations'

import Badge from '~/components/Badge'
import Button from '~/components/Buttons/Button'
import LastUpdatedByCard from '~/components/LastUpdatedByCard'
import { copyText } from '~/utils/navigator'

import './styles.scss'

interface Props {
  navigationGraphOptions: IOption[]
  onEdit: VoidFunction
  onHistoryClick: VoidFunction
  placementId: string
  placementOptions: IOption[]
  variations: IABTestVariation
}

const ABTestPlacementCard = ({
  navigationGraphOptions,
  onEdit,
  onHistoryClick,
  placementId,
  variations,
}: Props): ReactElement => {
  return (
    <div className="ab-test-placement-card">
      <div className="ab-test-placement-card__placement">
        <div className="ab-test-placement-card__placement__row">
          <div className="placement-container">
            <div className="placement-container__value">
              {placementId}
              <Button
                ghost
                onClick={() => copyText(placementId, 'Placement ID copied to clipboard.')}
                size="small"
                type="button"
              >
                <MdContentCopy size={14} />
              </Button>
              <Badge className="variation-iteration-badge" value={`#${variations.version}`} />
            </div>
          </div>
        </div>
        <div className="ab-test-placement-card__placement__row">
          <LastUpdatedByCard
            className="placement-metadata"
            labelClassName="placement-metadata__label"
            size="small"
            updatedBy={{
              date: variations.created_at_ts,
              name: variations.created_by,
              userId: variations.created_by,
            }}
          />
        </div>
      </div>
      <div className="ab-test-placement-card__variations">
        <ABTestVariations
          className="ab-test-variations--no-border"
          navigationGraphOptions={navigationGraphOptions}
          variations={variations}
        />
      </div>
      {!!onEdit ? (
        <div>
          <Button className="edit-button" onClick={onEdit}>
            <MdEdit color="#fff" size={15} />
          </Button>
          <Button onClick={onHistoryClick} outlined>
            <MdOutlineAccessTime color="#ff5301" size={15} />
          </Button>
        </div>
      ) : (
        <div className="empty-space" />
      )}
    </div>
  )
}

export default ABTestPlacementCard
